import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { CoinSearchInputProps } from "./types";
import NextImage from "@/src/components/NextImage";

export const CoinSearchInput: React.FC<CoinSearchInputProps> = ({
  value,
  onChange,
  selectedCoin,
  placeholder = "Search",
  onFocus,
  onBlur,
  isFource,
  disabled,
}) => {
  return (
    <div
      className={cn(
        "flex items-center px-3 h-9 rounded-2 border border-border_white_transparent5 bg-background_white_overlay5 relative",
        {
          "bg-background_white_overlay10": disabled,
        },
      )}
      id="coin-portal-container"
    >
      {!value && (
        <div
          className={cn(
            "flex gap-2 absolute pointer-events-none left-3 top-1/2 -translate-y-1/2",
          )}
        >
          {selectedCoin ? (
            <>
              <NextImage
                src={selectedCoin.coinIcon}
                alt={selectedCoin.coin}
                width={20}
                height={20}
                className={cn("w-5 h-5 rounded-full", {
                  ["opacity-50"]: isFource,
                })}
              />
              <span
                className={cn("body_medium_m text-content_primary", {
                  ["opacity-50"]: isFource,
                })}
              >
                {selectedCoin.coin}
              </span>
            </>
          ) : (
            <div className="body_m text-content_quaternary">{placeholder}</div>
          )}
        </div>
      )}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex-1 bg-transparent outline-none body_medium_m text-content_primary placeholder:text-content_tertiary h-9"
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
      />
      <Icon
        name="chevron-down"
        size={20}
        className={cn(
          "transition-transform duration-200 text-content_primary pointer-events-none absolute right-3 top-1/2 -translate-y-1/2",
          isFource && "rotate-180",
          {
            "text-content_quaternary": disabled,
          },
        )}
      />
    </div>
  );
};
